export const DOS_URL = 'https://digitaloriginalstandard.org/';
